import { gql } from '@apollo/client';

import { contentfulSysIdFragment } from '../../utils/contentful/contentfulQuery';

export const topicFragment = gql`
  fragment TopicAll on Topic {
    ...ContentfulSysId
    topicId
    displayText
    linksTo
  }
  ${contentfulSysIdFragment}
`;
